import { useState } from "react";
import axios from "axios";
import { Mail } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await axios.post(`${API}/contact`, formData);
      toast.success("Message sent! We'll be in touch soon.");
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch {
      toast.error('Failed to send. Please call us directly.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-[#111411] p-8 rounded-2xl border border-white/10">
      <h3 className="text-2xl font-bold text-[#F2F0E9] mb-6">Send a Message</h3>
      <form onSubmit={handleSubmit} className="space-y-5" data-testid="contact-form">
        <input type="text" name="name" placeholder="Your Name *" required value={formData.name} onChange={handleChange} className="form-input w-full px-5 py-4 rounded-xl" data-testid="contact-name-input" />
        <input type="email" name="email" placeholder="Email Address *" required value={formData.email} onChange={handleChange} className="form-input w-full px-5 py-4 rounded-xl" data-testid="contact-email-input" />
        <input type="tel" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} className="form-input w-full px-5 py-4 rounded-xl" data-testid="contact-phone-input" />
        <textarea name="message" placeholder="Your Message *" required rows={4} value={formData.message} onChange={handleChange} className="form-input w-full px-5 py-4 rounded-xl resize-none" data-testid="contact-message-textarea" />
        <button type="submit" disabled={isSubmitting} className="btn-cta w-full py-4 rounded-full flex items-center justify-center gap-2 disabled:opacity-50" data-testid="contact-submit-btn">
          {isSubmitting ? 'Sending...' : 'Send Message'}
          <Mail className="w-5 h-5" />
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
